import { jsx as $ } from "react/jsx-runtime";
import { memo as k, useState as I, useCallback as A, useEffect as _, createElement as E } from "react";
import M, { TAG_SIZE as S } from "../GeoTag/Geotag.js";
import { averageGeolocation as z } from "../../utils/map.js";
import O from "google-map-react";
import Z from "supercluster";
const b = process.env.GMAPS_API_KEY, R = 10, w = 19, U = (s, c, m, i) => {
  const g = Math.round(i == null ? void 0 : i.zoom), p = i == null ? void 0 : i.mapBoxBounds, a = s.map(
    (e) => ({
      id: e.id,
      type: "Feature",
      properties: {
        cluster: !1,
        point: e
      },
      geometry: {
        type: "Point",
        coordinates: [e.longitude, e.latitude]
      }
    })
  ), f = new Z({ radius: 75, maxZoom: w });
  f.load(a);
  const d = s.find((e) => e.id === (m == null ? void 0 : m.index));
  return p ? f.getClusters(p, g).map((e) => {
    const h = e.properties.cluster_id, r = h ? f.getLeaves(h, Number.MAX_SAFE_INTEGER) : [], L = r.find(
      (l) => {
        var y, B;
        return (d == null ? void 0 : d.id) && ((B = (y = l == null ? void 0 : l.properties) == null ? void 0 : y.point) == null ? void 0 : B.id) === d.id;
      }
    );
    return {
      ...e,
      open: L && !c,
      render: L ? d == null ? void 0 : d.render : void 0,
      children: r
    };
  }) : a;
}, K = ({
  points: s = [],
  updateMapData: c,
  setActivePlace: m,
  mapData: i,
  activePlace: g
}) => {
  const [p, a] = I({
    latitude: 0,
    longitude: 0
  }), [f, d] = I(!1), [e, h] = I(), [r, L] = I(), l = A(() => {
    if (!e || !r || !s.length)
      return;
    const n = new r.LatLngBounds();
    s.filter((t) => t.id !== "current-location").forEach(({ latitude: t, longitude: o }) => {
      const u = new r.LatLng(t, o);
      n.extend(u);
    }), e.fitBounds(n), e.panToBounds(n), e.addListener("center_changed", () => d(!0)), e.addListener("idle", () => d(!1));
  }, [r, e, s]);
  _(() => {
    l();
  }, [l]), _(() => (s.length && a(z(s)), () => {
    r && e && r.event.clearInstanceListeners(e), c();
  }), [s, r, e, c]);
  const y = ({ map: n, maps: t }) => {
    n.setOptions({ maxZoom: w }), h(n), L(t), l();
  }, B = A(
    (n) => () => {
      const t = n.children.map((u) => u.properties.point), o = new r.LatLngBounds();
      t.forEach(({ latitude: u, longitude: C }) => {
        const x = new r.LatLng(u, C);
        o.extend(x);
      }), e.fitBounds(o), e.panToBounds(o);
    },
    [r, e]
  ), G = A(
    ({ zoom: n, bounds: t }) => {
      const o = e == null ? void 0 : e.getBounds();
      c({
        zoom: n,
        bounds: o,
        mapBoxBounds: [t.nw.lng, t.se.lat, t.se.lng, t.nw.lat]
      });
    },
    [e, c]
  );
  return s.length ? /* @__PURE__ */ $(
    O,
    {
      bootstrapURLKeys: { key: b },
      center: p ? {
        lat: p.latitude,
        lng: p.longitude
      } : void 0,
      yesIWantToUseGoogleMapApiInternals: !0,
      onGoogleApiLoaded: y,
      zoom: R,
      hoverDistance: S / 2,
      options: {
        gestureHandling: "greedy"
      },
      onChange: G,
      children: U(s, f, g, i).map((n, t) => {
        const { point: o } = n.properties, [u, C] = n.geometry.coordinates, x = n.properties.cluster_id, T = n.properties.point_count;
        return n.properties.cluster ? /* @__PURE__ */ E(
          M,
          {
            ...o,
            index: t,
            lat: C,
            lng: u,
            key: `${C},${u},${x}`,
            content: T,
            open: n.open,
            isCluster: !0,
            onClick: B(n)
          },
          typeof n.render == "function" ? n.render() : null
        ) : o ? /* @__PURE__ */ E(
          M,
          {
            ...o,
            index: o.id,
            lat: o.latitude,
            lng: o.longitude,
            key: `${o.latitude},${o.longitude},${o.key}`,
            open: (g == null ? void 0 : g.index) === o.id && !f,
            onActivePlace: m
          },
          typeof o.render == "function" ? o.render() : null
        ) : null;
      })
    }
  ) : null;
}, q = k(K);
export {
  q as default
};
//# sourceMappingURL=UnitsMap.js.map
